//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
//import { ChartType } from 'angular-google-charts';
import { DataUserService } from '../../../services/data-user/data-user.service';
import { LoginService } from '../../../services/login/login.service';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { TiendaService } from '../../../services/tienda/tienda.service';
import { HttpErrorResponse } from '@angular/common/http';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { ConfigService } from '../../../services/config/config.service';
import { VentaService } from '../../../services/venta/venta.service';
import { ListaPreciosService } from '../../../services/lista-precios/lista-precios.service';


@Component({
  selector: 'app-begin-adm',
  templateUrl: './begin-adm.component.html',
  standalone: false,
  styleUrls: ['./begin-adm.component.scss']
})
export class BeginAdmComponent implements OnInit {

  loadMenu: boolean = false;
  load: boolean = false;
  empresa: Array<any> = [];
  token: any = {}
  menu: Array<any> = [];
  infoUser: any = {};
  lsTiendas: Array<any> = [];
  valueStorePay: number = 0;
  countStorePay: number = 0;
  data: any = [];
  ventaDiaria: number = 0;
  metaDiaria: number = 0;
  alerts: Array<any> = [];
  infoPagos: Array<any> = [];
  display: boolean = false;
  displayVendors: boolean = false;
  listSales: Array<any> = [];
  listSalesFilter: Array<any> = [];
  salesSelected: any = {};
  lsSexo: Array<any> = [{ id: 'M', label: 'Masculino' }, { id: 'F', label: 'Femenino' }, { id: 'O', label: 'Otro' }];
  newUser: Array<any> = [];
  filterUser: string = "";
  infoParametrizacion: any = {};
  checkedStateUser: boolean = true;

  listPrices: Array<any> = [];
  //********* */ representación del grafico*********/
  @ViewChild("chart") chart: any;
  public chartOptions: any;

  // datos grafica
  options: any;

  // canal de comunicación entre pestañas
  channel = new BroadcastChannel('channelSession');

  constructor(private dataUser: DataUserService,
    private tienda: TiendaService,
    private proveedor: ProveedorService,
    private parametrizacion: LoginService,
    private router: Router,
    private supplierIntegration: supplierIntegrationService,
    private localizacion: LocalizacionService,
    private config: ConfigService,
    private venta: VentaService,
    private listaPrecios: ListaPreciosService) { }

  ngOnInit(): void {
    /******************************Configuration Graphique ************************************************/
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor1 = documentStyle.getPropertyValue('--primary-color');
    const textColor2 = documentStyle.getPropertyValue('--colorSimescco');
    this.chartOptions = {
      series: [0, 0],
      chart: {
        width: 380,
        type: "donut",
      },
      labels: ["Venta", "Meta"],
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
          }
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 260
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      fill: {
        colors: [textColor1, textColor2]
      },

    };

    if (!localStorage.getItem('empresa')) {
      this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
      this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
      this.load = true;
      this.dataUser.getEmpresaVinculada(this.token.token).subscribe((response) => {
        this.empresa = response as Array<any>;
        localStorage.setItem('empresa', JSON.stringify(this.empresa));

        /// -----------------------------  import list prices --------------------------
        this.listaPrecios.get(this.token.token).subscribe({
          next: (response) => {
            this.load = false;
            this.listPrices = response as Array<any>;
            localStorage.setItem('listPrices', JSON.stringify(this.listPrices));
            console.log(response);
          },
          error: (error: HttpErrorResponse) => { if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); } this.load = false; }
        })
        // ----------------------------------------------------------------------------
        // load of states for invoicing
        this.localizacion.getDeptos(this.token.token, this.infoParametrizacion.idPaisVenta ?? 1).subscribe({
          next: (response) => { localStorage.setItem('listDptos', JSON.stringify(response as Array<any>)); },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        })

        // información de la parametrización del cliente
        this.parametrizacion.parametrizacion(this.token.token, this.empresa[0].idProveedor).subscribe((response1) => {
          localStorage.setItem('parametros', JSON.stringify(response1));
          this.infoParametrizacion = response1 as object;
          if (!!this.infoParametrizacion.dataIntegrationUser) {
            //********************************** get Token SIIGO *******************************************
            const data: any = {
              "dataIntegrationUser": this.infoParametrizacion.dataIntegrationUser,
              "dataIntegrationApikey": this.infoParametrizacion.dataIntegrationApikey
            }
            this.supplierIntegration.getTokenSIIGO(this.token.token, data).subscribe({
              next: (response) => {
                localStorage.setItem('tokenSIIGO', JSON.stringify(response));
              },
              error: (error: HttpErrorResponse) => {
                this.alerts.push({
                  type: 'error',
                  text: 'Se ha presentado un error con el proveedor SIIGO, no es posible conectarse, cierre sesión e intente nuevamente'
                });
              }
            });
          }
          //************************************************************************************************ */
        });

        // obtener el menu
        this.dataUser.getMenuProfile(this.token.token).subscribe((response) => {
          this.menu = response as Array<any>;
          console.log('menu', this.menu);
          localStorage.setItem('menu', JSON.stringify(this.menu));
          this.loadMenu = true;
          this.load = false;
        });

        const dateConvert = this.config.formatDateUnique(new Date())

        this.tienda.getTiendas(this.token.token, dateConvert).subscribe((response) => {
          this.lsTiendas = response as Array<any>;
          localStorage.setItem('tiendas', JSON.stringify(this.lsTiendas));

          // cargar información de pago
          this.venta.getMetodoPago(this.token.token).subscribe((response: any) => {
            localStorage.setItem("metodoPago", JSON.stringify(response as Array<any>));
          });

          // obtener las metas de cada tienda, seria la sumatoria
          this.lsTiendas.map((row) => {
            // revisar pendientes de las tienda en pago
            if (row.pagoPendiente > 0) {
              this.valueStorePay += row.pagoPendiente;
              this.countStorePay++;
            }
            if (row.metaTienda.length > 0)
              this.metaDiaria += row.metaTienda[0].valor ?? 0
          });
          // generando alertas
          if (this.valueStorePay > 0) {
            this.alerts.push({
              type: 'warn',
              text: 'Tienes un pago pendiente por valor de ' + this.valueStorePay + ', equivalente a ' + this.countStorePay + ' tienda(s): ' + (this.lsTiendas.filter((item: any) => { return item.pagoPendiente > 0 }).map((row) => { return row.nombreTienda }).join(','))
            });
          }

          this.proveedor.getVentasDiscriminacionPagoProveedor(this.token.token, dateConvert, this.infoUser.empleadoProveedors[0].idProveedor).subscribe((response) => {
            this.infoPagos = response as Array<any>;
            this.infoPagos.map(row => {
              this.ventaDiaria += row.valor;
            });
            //******************************************** begin graphique ***********************************************
            this.chartOptions.series = [this.ventaDiaria, ((this.metaDiaria - this.ventaDiaria) < 0) ? 0 : this.metaDiaria - this.ventaDiaria]
            //******************************************** End graphique ***********************************************

            // validar si hay una meta o  si no informar al usuario
            if (this.metaDiaria == 0)
              this.alerts.push({
                type: 'warn',
                text: 'No se ha establecido una meta, recuerda asignarla'
              });

          });
        });
      });
    }
    // cuando ya esta logueado el usuario
    else {
      this.loadMenu = true;
      this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
      this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
      this.lsTiendas = JSON.parse(localStorage.getItem('tiendas') ?? "[]");
      this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
      this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
      this.listPrices = JSON.parse(localStorage.getItem('listPrices') ?? "[]");

      this.metaDiaria = 0;
      // obtener las metas de cada tienda, seria la sumatoria
      this.lsTiendas.map((row) => {
        // revisar pendientes de las tienda en pago
        if (row.pagoPendiente > 0) {
          this.valueStorePay += row.pagoPendiente;
          this.countStorePay++;
        }
        if (row.metaTienda.length > 0)
          this.metaDiaria += row.metaTienda[0].valor ?? 0
      });
      // generando alertas
      if (this.valueStorePay > 0) {
        this.alerts.push({
          type: 'warn',
          text: 'Tienes un pago pendiente por valor de ' + this.valueStorePay + ', equivalente a ' + this.countStorePay + ' tienda(s): ' + (this.lsTiendas.filter((item: any) => { return item.pagoPendiente > 0 }).map((row) => { return row.nombreTienda }).join(','))
        });
      }

      let fecha: Date = new Date();
      const dateConvert = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + "-" + fecha.getDate();
      this.proveedor.getVentasDiscriminacionPagoProveedor(this.token.token, dateConvert, this.infoUser.empleadoProveedors[0].idProveedor).subscribe({
        next: (response: any) => {
          this.infoPagos = response as Array<any>;
          this.infoPagos.forEach(row => {
            this.ventaDiaria += row.valor;
          });
          //******************************************** begin graphique ***********************************************
          this.chartOptions.series = [this.ventaDiaria, ((this.metaDiaria - this.ventaDiaria) < 0) ? 0 : this.metaDiaria - this.ventaDiaria]
          //******************************************** End graphique ***********************************************

          // validar si hay una meta o  si no informar al usuario
          if (this.metaDiaria == 0)
            this.alerts.push({
              type: 'warn',
              text: 'No se ha establecido una meta, recuerda asignarla'
            });
        }, error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
          this.alerts.push({
            type: 'warn',
            text: 'Se ha presentado un error, favor intente nuevamente'
          });
          this.load = false;
        }
      });
    }

  }

  openDialogCreateUser = () => {
    this.load = true;
    // seobtiene la informaciòn de los vendedores
    this.proveedor.getVendedoresActivos(this.token.token, 4).subscribe((response) => {
      this.listSales = response as Array<any>;

      // manipulacion del array de empleados
      let array: any = this.listSales.map(row => {
        row.idEmpleadoNavigation.idUserIntegrationSystem = row.idUserIntegrationSystem;
        return row.idEmpleadoNavigation
      });
      array.map((element: any) => {
        element.fechaNacimiento = new Date(element.fechaNacimiento);
      });

      this.listSales = array;
      // visualización de empleados solo activos
      this.listSalesFilter = this.listSales.filter((row) => {
        return (row.activo == this.checkedStateUser)
      });
      this.display = true;
      this.load = false;
    });
  }

  addUser = (event: any) => {
    if (!event.collapsed)
      this.newUser = [{
        "idPerfil": 4,
        "identificacion": null,
        "nombres": "",
        "apellidos": "",
        "genero": "",
        "fechaNacimiento": new Date("1900-01-01T00:00:00"),
        "email": "",
        "idCargo": 4,
        "activo": true,
      }];
  }

  createUser = (row: any, isNew?: boolean) => {
    row.msgUser = "";
    // validar que todos los campos vengan
    if ((row.identificacion ?? "").trim() == "") {
      row.msgUser = "<div class='p-message p-message-warn'>Favor ingrese la identificación</div>";
      return;
    }
    else if (row.nombres.trim() == "") {
      row.msgUser = "<div class='p-message p-message-warn'>Favor ingrese el nombre</div>";
      return;
    }
    else if (row.apellidos.trim() == "") {
      row.msgUser = "<div class='p-message p-message-warn'>Favor ingrese los apellidos</div>";
      return;
    }
    else if (row.genero == "") {
      row.msgUser = "<div class='p-message p-message-warn'>Favor seleccione el genero</div>";
      return;
    }
    else if (new Date(row.fechaNacimiento.toString()).getFullYear() <= 1900) {
      row.msgUser = "<div class='p-message p-message-warn'>Favor ingrese la fecha de nacimiento</div>";
      return;
    }
    else if ((this.infoParametrizacion?.integrationSystem ?? "" != '') && (row.idUserIntegrationSystem ?? "").length == 0) {
      row.msgUser = "<div class='p-message p-message-warn'>Favor ingrese el id del sistema " + this.infoParametrizacion.integrationSystem + "</div>";
      return;
    }

    //borrar propiedad
    delete row.msgUser;
    const data: any = {
      "idPerfil": row.idPerfil,
      "idCargo": row.idPerfil,
      "identificacion": row.identificacion,
      "nombres": row.nombres.trim(),
      "apellidos": row.apellidos.trim(),
      "genero": row.genero,
      "fechaNacimiento": new Date(row.fechaNacimiento),
      "email": row.email.trim(),
      "activo": row.activo == 1 ? true : false,
      "empleadoProveedors": [
        {
          "idUserIntegrationSystem": row.idUserIntegrationSystem
        }]
    };
    this.load = true;
    this.proveedor.setUsers(this.token.token, data).subscribe({
      next: (response) => {
        row.msgUser = "<div class='p-message p-message-success'>" + response as string + "</div>";
        // si es nuevo el usuario se deja los campos en blanco
        if (isNew) {
          this.newUser = [{
            "idPerfil": 4,
            "identificacion": null,
            "nombres": "",
            "apellidos": "",
            "genero": "",
            "fechaNacimiento": new Date("1900-01-01T00:00:00"),
            "email": "",
            "idCargo": 4,
            "activo": true,
          }];
          this.openDialogCreateUser()
        }
        this.load = false;
      }, error: (error: Response) => {
        row.msgUser = "<div class='p-message p-message-dang'>Se ha presentado un error</div>";
        this.load = false;
      }
    })

  }

  actionSelectedVendors = (identificacion: any) => {
    this.salesSelected = this.listSales.filter((row: any) => {
      return row.identificacion == identificacion;
    })[0];
    this.displayVendors = true;
  }

  filterUsers = () => {
    this.listSalesFilter = this.listSales.filter((row) => {
      return (((row.nombres.toLowerCase().indexOf(this.filterUser.toLowerCase()) > -1) || (row.apellidos.toLowerCase().indexOf(this.filterUser.toLowerCase()) > -1)) && row.activo == this.checkedStateUser)
    });
  }

  navegar = (enlace: string, mobile: boolean, plusPx?: number) => {
    const el: any = document.getElementById(enlace);
    window.scrollTo(0, el.offsetTop + (mobile ? el.offsetParent.offsetTop : 0) + (plusPx ?? 0));
  }



}
